export default __webpack_public_path__ + "static/media/logo.4185c646.svg";